import { styled } from 'linaria/react';
export const IconButton = /*#__PURE__*/styled("button")({
  name: "IconButton",
  class: "it1hknk",
  vars: {
    "it1hknk-0": [props => props.icon],
    "it1hknk-1": [props => props.size || '22px']
  }
});